import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, AfterContentInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { generateRandomIdentifier } from '../../ui.service';
import { DocumentFileTypeDTO, FileDetailsDTO, InboxDTO, getSimpleIdentifierFromString, ProfileDTO } from '../../api/plyca-dtos';
import { PropertyService } from '../../properties/property.service';
import { HelpType } from '../../components/common/help/help.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng-lts/dynamicdialog';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import * as lodash from 'lodash';

export class InboxModel {

  dto: InboxDTO;
  ui: any;
}

@Component({
  selector: 'inbox-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class InboxEditionComponent
  extends BaseFormComponent<InboxDTO, InboxModel>
  implements OnInit, AfterContentInit, OnDestroy {

  private identifier: string;

  dossierId: any;
  loteId: any;

  invoice: any;
  readonly = false;
  accionModal = '';
  contractTotal = 0;
  invoicesTotal = 0;

  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    public dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private propertyService: PropertyService,
    private plycaErrorHandler: PlycaErrorHandler,
    @Optional() protected activatedRoute: ActivatedRoute

  ) {
    super(elem);
    this.identifier = dialogConfig['id'];
    this.readonly = dialogConfig['readonly'] ? dialogConfig['readonly'] : false;
    this.accionModal = dialogConfig['accion'];

    this.windowHash = generateRandomIdentifier();
  }

  ngOnDestroy(): void {
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }



  ngAfterContentInit(): void {



  }

  getFormSettingURL(): string {
    return 'admin/inboxISettings.json';
  }

  getServiceURL(): string {
    return this.configuration.INBOX_SERVICE_URL;
  }
  getObjectParams(): { [param: string]: string | string[]; } {
    return {

      'expand': 'expansionSet:EDITION'
    };
  }

  getObjectIdentifier(): string {
    return this.identifier;
  }


  dtoToModel(dto: InboxDTO): Observable<any> {
    let params: any = {};
    params.retrievAllProfilesApplicationData = true;
    return this.plycaService.query<any>(
      this.configuration.PROFILES_SERVICE_URL + '', params)
      .pipe(
        map(
          (resp) => {
            let localModel = new InboxModel();
            // inicializacion de los campos del modelo utilizados por el json

            localModel.dto = dto;






            // Iniciamos el ui
            localModel.ui = {};
            localModel.ui.allProfiles = {};


            if (resp && resp.content) {
              localModel.ui.allProfiles = resp.content;


              localModel.ui.allProfiles.map((profile) => {
                profile.description = profile.description + ' - ' + profile.application;
                profile.identifier = profile.identifier + '<>' + profile.application;
              }

              )

              if (localModel.dto.inboxProfiles && localModel.dto.inboxProfiles.length > 0) {
                localModel.dto.inboxProfiles.map((element) => {
                  // ip.profile.description = profile.description + ' - ' + profile.application;
                  element.uuid = element.identifier;
                  element.identifier = element.profile.identifier + '<>' + element.application;
                });

              }


            } else {
              localModel.ui.allProfiles = [];
            }

            return localModel
          }
        ),
        catchError(
          (err) => {

            this.plycaErrorHandler.showServerError(err);
            this.waitService.cancelWaiting();
            this.ref.close();
            return of(true);
          })
        , finalize(() => {


        }
        ));






  }






  modelToDTO(model: InboxModel): InboxDTO {
    let localDto: InboxDTO;
    localDto = lodash.cloneDeep(model.dto);
    if (model.dto && model.dto.inboxProfiles) {
      localDto.inboxProfiles.map((element) => {
        if (!element.uuid) {
          element.profile = new ProfileDTO;
          element.profile.identifier = getSimpleIdentifierFromString(element.identifier);
          element.identifier = undefined;
        } else {
          element.identifier = element.uuid;
          element.uuid = undefined;
        }



      }

      )
    }


    localDto = JSON.parse(
      JSON.stringify(localDto, (k, v) => (k === '_parent' ? undefined : v))
    );
    return localDto;

  }

  getTitle(model: InboxDTO): string {

    return 'ControlPanel.inboxs.title';
    /*
    if (model) {
      return 'Inboxs.edit';
    } else {
      return 'Inboxs.add';
    }*/
  }



  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = this.getTitle(this.model.dto);
    headerInfo.titleIcon = 'fas fas fa-file-invoice-dollar';

    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  initHeaderActions() {

    if (!this.readonly) {
      this.subscribe(this.headerActionsService
        .addWindowAction('General.save', 'fas fa-save', 'btn-primary', true, this.windowHash),

        (() => {

          this.subscribe(this.save(),
            (newInbox: InboxDTO) => {
              this.waitService.cancelWaiting();
              this.uiService.showSuccess(this.translate.instant('General.msg.updateok'), this.translate.instant('General.info'),
                'success');
              this.ref.close(newInbox);
            },
            (err) => {
              this.waitService.cancelWaiting();
              this.uiService.showSuccess('Se ha producido un error al actualizar', this.translate.instant('General.info'),
                'error');
              // Revisar ¿error de validación? Error 404
              // this.plycaErrorHandler.showServerError(err);
            })

        }))
    }

  }



  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = true;
    formConfig.windowHash = this.windowHash;
    formConfig.readonly = this.readonly;
    formConfig.searchTags = [HelpType.EDIT_INBOX];

    formConfig.functions.push({
      identifier: 'valueName',
      fn: this.valueName
    });
    return of(formConfig);
  }

  // Valor del campo Directiva de aplicacion
  public valueName(model: any) {
    if (model.dto.company && model.dto.company.commercialName) {
      model.dto.company.name = model.dto.company.commercialName;
      model.dto.taxIdentifier = model.dto.company.taxIdentifier;
    }

  }

  /*  ¿Mover a documentService?*/

  private initDraftFiles(dto): void {

    let tmpDrafFiles: Array<FileDetailsDTO> = [];
    let temporalFiles: Array<FileDetailsDTO> = [];
    if (
      dto != null && dto.document != null &&
      dto.document.currentVersion != null &&
      dto.document.currentVersion.files != null
    ) {
      let allFiles: Array<FileDetailsDTO> = [];
      tmpDrafFiles = this.documentService.getTypeDocument(
        DocumentFileTypeDTO.Draft,
        dto.document
      );
      temporalFiles = this.documentService.getTypeDocument(
        DocumentFileTypeDTO.Temporal,
        dto.document
      );
      allFiles = tmpDrafFiles.concat(temporalFiles);

      dto.document.currentVersion.files = allFiles;
    } else {
      dto.document.currentVersion.files = tmpDrafFiles;
    }

  }

  modalError(error) {
    this.ref.close();
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }


  guardar() {
    this.subscribe(this.save(),
      (newInbox: InboxDTO) => {
        this.waitService.cancelWaiting();
        this.uiService.showSuccess('El buzón se ha actualizado correctamente.', this.translate.instant('General.info'),
          'success');
        this.ref.close(newInbox);
      })
  }
  eliminar() {


    this.uiService.showConfirmMessage({
      message: this.translateService.instant(
        'Inboxs.reject.warning'
      ),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {

        let url = '';
        this.subscribe(this.plycaService.simpleUpdate(
          url,
          new Object()
        ),
          (result) => {
            this.waitService.cancelWaiting();
            this.ref.close(result);
          },
          (error: any) => {
            this.manageActionError(error, true);


          })
      },
      reject: () => {
        this.ref.close();
      }
    });



  }
}
